import { Fetch } from 'barnyard/utils/';
import * as constants from '../constants';
import { browserHistory } from 'react-router';
import { startSubmit, stopSubmit, reset } from 'redux-form';
import { addNotification } from '~/app/common/packages/notifications';

export const corporateRegionCreate = form => (dispatch, getState) => Fetch({
  url: '/api/corporates/corporateregions/',
  method: 'POST',
  body: form,
  before: () => {
    dispatch(startSubmit('region'));
    dispatch({
      type: constants.CORPORATE_REGION_CREATE_REQUEST
    });
  },
  success: (json) => {
    dispatch({
      type: constants.CORPORATE_REGION_CREATE_SUCCESS,
      entity: json,
      corporate_region_id: json.id
    });
    browserHistory.push('/corporate/settings/regions');
  },
  failure: (error) => {
    dispatch(stopSubmit('region', { _error: error }));
  }
});

export const corporateRegionUpdate = (corporate_region_id, form) => (dispatch, getState) => Fetch({
  url: `/api/corporates/corporateregions/${corporate_region_id}/`,
  method: 'PATCH',
  body: form,
  before: () => {
    dispatch(startSubmit('region'));
  },
  success: (json) => {
    dispatch({
      type: constants.CORPORATE_REGION_UPDATE_SUCCESS,
      entity: json,
      corporate_region_id
    });
    browserHistory.push('/corporate/settings/regions');
  },
  failure: (error) => {
    dispatch(stopSubmit('region', { _error: error }));
  }
});

export const corporateRegionDelete = corporate_region_id => (dispatch, getState) => Fetch({
  url: `/api/corporates/corporateregions/${corporate_region_id}/`,
  method: 'DELETE',
  before: () => {
    dispatch({
      type: constants.CORPORATE_REGION_DELETE_REQUEST,
      corporate_region_id
    });
  },
  success: (json) => {
    dispatch({
      type: constants.CORPORATE_REGION_DELETE_SUCCESS,
      corporate_region_id
    });
  },
  failure: (error) => {
    dispatch({
      type: constants.CORPORATE_REGION_DELETE_FAILURE,
      corporate_region_id
    });
    dispatch(
      addNotification({
        value: 'Error deleting corporate region',
        is_error: true
      })
    );
  }
});

